import { DATA_SOURCE_CONFIG } from '../config/appConfig';

/**
 * 配置服务类
 * 管理应用配置和服务器连接
 */
class ConfigService {
  constructor() {
    this.config = DATA_SOURCE_CONFIG;
  }

  /**
   * 检查是否使用服务器数据
   */
  useServerData() {
    return this.config.USE_SERVER_DATA;
  }

  /**
   * 获取服务器URL
   * 优先使用环境变量 REACT_APP_API_URL，否则使用配置文件中的 SERVER_URL
   * 如果在生产域名上运行，自动使用相对路径（空字符串）
   */
  getServerUrl() {
    // 优先使用环境变量
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }
    
    // 如果在浏览器环境中，检测当前域名
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      // 如果是生产域名，使用相对路径（空字符串）
      if (hostname === 'yogaflow.com.cn' || hostname === 'www.yogaflow.com.cn' || hostname === '139.224.209.106') {
        return '';
      }
    }
    
    // 否则使用配置文件中的默认值
    return this.config.SERVER_URL;
  }

  /**
   * 获取API基础路径
   */
  getApiBasePath() {
    return this.config.API_BASE_PATH;
  }

  /**
   * 获取完整的API URL
   */
  getApiUrl(endpoint = '') {
    if (!this.useServerData()) {
      return null;
    }
    
    const baseUrl = this.getServerUrl();
    const basePath = this.getApiBasePath();
    
    // 确保endpoint以/开头
    if (endpoint && !endpoint.startsWith('/')) {
      endpoint = '/' + endpoint;
    }
    
    return `${baseUrl}${basePath}${endpoint}`;
  }

  /**
   * 验证服务器连接
   */
  async testServerConnection() {
    const testUrl = this.getApiUrl('/poses/');

    try {
      console.log(`Testing connection to: ${testUrl}`);
      const response = await fetch(testUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Server connection test successful:', data);
        return { success: true, message: '服务器连接正常' };
      } else {
        console.error('Server response error:', response.status, response.statusText);
        return { success: false, message: `服务器响应错误: ${response.status} ${response.statusText}` };
      }
    } catch (error) {
      console.error('Server connection test failed:', error);
      return { 
        success: false, 
        message: `连接失败: ${error.message}` 
      };
    }
  }

  /**
   * 获取数据源描述
   */
  getDataSourceDescription() {
    if (this.useServerData()) {
      return `服务器模式 - ${this.getServerUrl()}`;
    } else {
      return '本地文件模式';
    }
  }

  /**
   * 切换数据源（仅用于开发调试）
   */
  toggleDataSource() {
    console.warn('切换数据源需要修改配置文件并重启应用');
    return this.useServerData();
  }

  /**
   * 获取配置信息
   */
  getConfigInfo() {
    return {
      useServerData: this.useServerData(),
      serverUrl: this.getServerUrl(),
      apiBasePath: this.getApiBasePath(),
      dataSourceDescription: this.getDataSourceDescription(),
    };
  }
}

// 创建单例实例
const configService = new ConfigService();

export default configService;
